export { LoadingSpinner } from "./component";
export type {
  LoadingSpinnerProps,
  LoadingSpinnerStyleProps,
  SpinnerColor,
  SpinnerSize,
  SpinnerSpeed,
  SpinnerVariant,
} from "./types";
